'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MastercardIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.2 12C14.2 15.2 11.6 17.8 8.40005 17.8C5.20005 17.8 2.80005 15.2 2.80005 12C2.80005 8.80001 5.40005 6.20001 8.60005 6.20001C11.8 6.20001 14.2 8.80001 14.2 12ZM15.5 6.20001C12.3 6.20001 9.70005 8.80001 9.70005 12C9.70005 15.2 12.3 17.8 15.5 17.8C18.7 17.8 21.3 15.2 21.3 12C21.3 8.80001 18.7 6.20001 15.5 6.20001Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpMastercardIcon = forwardRef(MastercardIcon);

export { VpMastercardIcon as default };
